import styled from 'styled-components';
import { theme } from 'assets/styles/theme';

import { DeviceUp } from 'assets/styles/breakpoints';

export const DatePickerStyle = styled.div`
  margin-bottom: 20px;

  .date-label {
    display: block;
    font-size: 18px;
    margin: 0 0 9px;
  }

  .date-label,
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    display: block;
  }

  .react-datepicker__day--selected {

    &, &:hover {
      background-color: ${theme.primary};
    }
  }

  .date-row {
    position: relative;
    max-width: 182px;
  }
`;

export const DrawerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .42);
  overflow-y: auto;
  padding: 15px;
  transition: opacity .3s linear;
  z-index: 100;

  @media ${DeviceUp.sm} {
    padding: 15px 35px 10px;
  }

  &.drawer-hidden {
    opacity: 0;
    pointer-events: none;
  }

  &.drawer-shown {

    .drawer-content {
      transform: translateX(-100%);
    }
  }

  .drawer-content {
    position: fixed;
    top: 0;
    left: 100%;
    height: 100%;
    background: #fff;
    width: 100%;
    max-width: 795px;
    transition: transform .3s linear;

    @media ${DeviceUp.sm} {
      width: 90%;
    }
  }

  .drawer-header {
    border-bottom: 2px solid #aaa;
    padding: 15px;
    flex-wrap: wrap;
    gap: 12px;

    @media ${DeviceUp.sm} {
      padding: 55px 77px 17px 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    button {
      padding: 0 20px;

      @media ${DeviceUp.xxxs} {
        padding: 0 28px;
      }

      .icon {
        margin: 0px 0 0 10px;
        font-size: 19px;
        display: inline-block;
        vertical-align: top;
      }

      &.link {
        padding: 10px 0 0 0;
        color: ${theme.secondary};
        @media ${DeviceUp.sm} {
          padding: 0 28px;
          margin-top: 12px;
        }
      }

      + button {
        margin-left: 21px;
      }
    }

    h3 {
      font-size: 28px;
      font-weight: 700;
      margin: 0 13px 0 0;

      @media ${DeviceUp.sm} {
        margin: 3px 5px 0 0;
      }
    }

    @media ${DeviceUp.sm} {
      .btn-group {
        margin-left: auto;
      }

      .outline {
        margin-left: auto;
      }
    }
  }

  .drawer-body {
    padding: 30px 15px 0;
    overflow-y: auto;
    max-height: calc(100% - 122px);

    @media ${DeviceUp.sm} {
      padding: 34px 69px 0;
    }
  }

  .drawer-row {
    @media ${DeviceUp.lg} {
      display: flex;
      justify-content: space-between;
    }
  }

  .drawer-col {
    padding-bottom: 49px;
    width: 100%;
    max-width: 100%;

    @media ${DeviceUp.lg} {
      flex-basis: 47%;
      max-width: 47%;
      width: auto;
    }

    &:first-child {
      @media ${DeviceUp.lg} {
        flex-basis: 40%;
        max-width: 40%;
      }
    }

    .checkbox-list {

      li {
        margin-bottom: 17px;

        label {
          display: block;
        }
      }
    }

    .checkbox {
      display: block;
      &:before {
        top: 5px;
      }
      svg {
        top: 10px;
      }
      .text {
        padding-left: 14px;
      }
    }

    header {
      display: flex;
      padding-bottom: 26px;

      .link {
        margin-top: 5px;
        vertical-align: top;
        color: ${theme.secondary};

        .icon {
          margin: 3px 0 0 4px;
          transition: transform .3s ease;
          display: inline-block;
          vertical-align: top;
        }
      }

      .list-shown {

        svg {
          transform: rotate(-180deg);
        }
      }

      h4 {
        margin: 0;
        font-size: 24px;
        line-height: 1.1;
      }

      .checkbox {

        svg {
          top: 9px;
        }

        &:before {
          top: 4px;
        }

        &:after {
          top: 6px;
        }

        .text {
          font-size: 24px;
          font-weight: 600;
        }
      }
    }
  }
  .status-note {
    font-size: 12px;
    line-height: 15px;
    color: #70787E;
    display: block;
    margin:  4px 0 0 34px;
  }
  .search-block {
    border: 2px solid ${theme.gray};
    border-radius: 4px;
    flex-grow: 1;
    height: 48px;
    display: flex;
    align-items: center;
    margin:  0 0 25px;

    @media ${DeviceUp.sm} {
      flex-grow: inherit;
      width: 315px;
    }
    .icon-Search-2-Outline-Color {
      font-size: 20px;
      margin: 12px 12px 12px 17px;
    }
    input[type="search"] {
      border: 0;
      color: ${theme.primaryText};
      font-size: ${theme.lgFontSize};
      height: 42px;
      flex-grow: 1;
      padding-right: 15px;
      position: relative;
      width: 100%;

      &::-webkit-input-placeholder {
        color: ${theme.primaryText};
      }

      &:-ms-input-placeholder {
        color: ${theme.primaryText};
      }

      &::placeholder {
        color: ${theme.primaryText};
      }
    }
  }
`;

export const HeadingHolder = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 15px;
  justify-content: flex-start;
`;

export const ButtonsHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
